import React from "react";
import LegalPage from "../components/LegalPage";

const SECTIONS = [
  {
    id: "purpose",
    heading: "1. Purpose",
    body: [
      "This Refund & Cancellation Policy explains when refunds, cancellations, credits, extensions of access and other remedies may be available for Medily products and services.",
    ],
  },
  {
    id: "scope",
    heading: "2. Scope",
    body: [
      "This policy applies to the Resources Pack (£29.99/month), Mock MMI Sessions (£119.99), Bundle Package (£129.99), AI Interviewer access and any related services provided by Medily.",
    ],
  },
  {
    id: "resources-pack-subscription",
    heading: "3. Resources Pack Subscription",
    body: [
      "The Resources Pack is a monthly subscription priced at £29.99 per month. Access begins immediately after successful payment and includes access to the AI Interviewer and associated resources.",
      "The Resources + Maya subscription includes access to 15 AI Maya interview stations per monthly billing cycle. Your allowance resets automatically on each monthly renewal date. Any unused interview stations expire at the end of the current billing cycle and do not roll over to future months.",
    ],
  },
  {
    id: "subscription-renewals",
    heading: "4. Subscription Renewals",
    body: [
      "Subscriptions are renewed automatically each month until cancelled. Users may cancel at any time before the next billing date. Cancellation prevents future charges and access continues until the end of the paid billing period.",
    ],
  },
  {
    id: "resources-pack-refunds",
    heading: "5. Resources Pack Refunds",
    body: [
      "5.1  If required by applicable consumer law, users may retain statutory cancellation or refund rights where digital content has not yet begun or where Medily has not yet started supplying the service.",
      "Once access to the Resources Pack has been granted and the service has started, refunds are not available for the current billing period except where required by applicable law.",
    ],
  },
  {
    id: "ai-interviewer",
    heading: "6. AI Interviewer",
    body: [
      "6.1  References to the AI Interviewer include Medily’s AI coach, Maya. Monthly AI station allowances do not roll over into future billing periods.",
      "The AI Interviewer forms part of the Resources Pack. Once access has been granted and the tool has been made available, no refund is available for the current billing period except where required by law.",
    ],
  },
  {
    id: "mock-mmi-sessions",
    heading: "7. Mock MMI Sessions",
    body: [
      "Mock MMI Sessions are one-off purchases priced at £119.99. A full refund is available where cancellation is requested more than 48 hours before the scheduled session.",
    ],
  },
  {
    id: "mock-mmi-late-cancellations",
    heading: "8. Mock MMI Late Cancellations",
    body: [
      "No refund is available where cancellation occurs within 48 hours of the scheduled session.",
    ],
  },
  {
    id: "rescheduling",
    heading: "9. Rescheduling",
    body: [
      "9.1  One complimentary reschedule may be permitted where at least 48 hours’ notice is provided, subject to availability. Further changes may incur an administrative fee.",
      "Medily may permit rescheduling of a Mock MMI at its discretion, subject to interviewer availability and operational requirements.",
    ],
  },
  {
    id: "no-shows-and-lateness",
    heading: "10. No Shows and Lateness",
    body: [
      "10.1  If a student experiences genuine technical difficulties joining an online Mock MMI, they should contact Medily immediately. Appropriate remedies may be offered at Medily’s discretion.",
      "Students arriving more than 15 minutes late may be treated as non-attendees. Missed sessions and no-shows are not eligible for refunds.",
    ],
  },
  {
    id: "bundle-package",
    heading: "11. Bundle Package",
    body: [
      "The Bundle Package is priced at £129.99 and includes one Mock MMI Session and one month of Resources Pack access. After the first month, the Resources Pack renews automatically at the standard subscription price unless cancelled.",
    ],
  },
  {
    id: "bundle-refunds",
    heading: "12. Bundle Refunds",
    body: [
      "Refund entitlement for each component of the Bundle will be assessed according to the relevant provisions of this policy.",
    ],
  },
  {
    id: "technical-issues",
    heading: "13. Technical Issues",
    body: [
      "13.1  Planned maintenance or temporary outages do not automatically entitle users to refunds where Medily provides a reasonable alternative remedy such as an extension of access.",
      "Where technical failures affect access to the Resources Pack, AI Interviewer or student portal, Medily may provide an extension of access, service credit, replacement access, alternative equivalent service or another reasonable remedy. Refunds are not automatically provided.",
    ],
  },
  {
    id: "failed-payments",
    heading: "14. Failed Payments",
    body: ["Medily may suspend access where payments fail, are reversed or remain outstanding."],
  },
  {
    id: "chargebacks",
    heading: "15. Chargebacks",
    body: [
      "Where a chargeback is initiated after resources have been accessed, AI tools used, or services delivered, Medily reserves the right to challenge the chargeback and provide supporting evidence to the payment provider.",
    ],
  },
  {
    id: "exceptional-circumstances",
    heading: "16. Exceptional Circumstances",
    body: [
      "16.1  Supporting evidence may be requested before exceptional refunds, credits or rescheduling requests are approved.",
      "Medily may, at its discretion, consider refunds, credits, rescheduling or extensions in cases of serious illness, hospitalisation, bereavement or other exceptional emergencies.",
    ],
  },
  {
    id: "complaints",
    heading: "17. Complaints",
    body: [
      "17.1  Medily aims to acknowledge complaints within five working days and resolve them as promptly as reasonably possible.",
      "Refund disputes and complaints should be submitted to info@medily.co. Medily will investigate and respond within a reasonable period.",
    ],
  },
  {
    id: "consumer-rights",
    heading: "18. Consumer Rights",
    body: ["Nothing in this policy limits statutory consumer rights under applicable law."],
  },
  {
    id: "contact-details",
    heading: "19. Contact Details",
    body: ["Email: info@medily.co"],
  },
];

const RefundCancellationPolicy = () => (
  <LegalPage
    title="Refund & Cancellation Policy"
    subtitle="When refunds, cancellations, credits, extensions of access and other remedies may be available for Medily products and services."
    sections={SECTIONS}
  />
);

export default RefundCancellationPolicy;
